import { AutoLinkContext } from '@betterment/js-runtime';
import { SentryErrorBoundary } from '@betterment/shared-components';
import { RouterProvider, RouterProviderProps, createBrowserRouter } from 'react-router-dom';

import { NotFound } from '../RetailApp/components/NotFound';
import { pangeaRoutes } from '../RetailApp/components/PangeaRoutes';
import { Root } from '../RetailApp/components/Root';
import { RetailAppProvider } from '../RetailApp/providers/RetailAppProvider';
import { urlBuilder } from '../Shared/urlBuilder';

type Router = RouterProviderProps['router'];

export type RetailAppProps = {
  router: Router;
};

const autoLinkContextValue = {
  routes: pangeaRoutes,
  basename: urlBuilder.appHome.absolute(),
};

/**
 * Turbolinks uses `window.history.pushState`, which React Router does not see. The solution
 * is to create a brand new router each time the `react-spa-controller` reconnects, which is
 * a very good indication that Turbolinks handled the page load. This forces React Router to
 * recompute the current location.
 */
export function createRouter(): Router {
  return createBrowserRouter(
    [
      {
        path: '/',
        element: <Root />,
        children: [...pangeaRoutes, { path: '*', element: <NotFound /> }],
      },
    ],
    { basename: urlBuilder.appHome.absolute() }
  );
}

const RetailApp: React.FC<RetailAppProps> = ({ router }) => (
  <SentryErrorBoundary fallbackType="full">
    <RetailAppProvider>
      <AutoLinkContext.Provider value={autoLinkContextValue}>
        <RouterProvider router={router} />
      </AutoLinkContext.Provider>
    </RetailAppProvider>
  </SentryErrorBoundary>
);

export default RetailApp;
